import React, { useEffect } from "react";
import People from "../../Assests/Frame 2147225065.png";
import logo from "../../Assests/Frame 21472272301.svg";
import payroll from "../../Assests/Frame 2147227247.svg";
import person from "../../Assests/Frame 2147227245.png";
import Tick from "../../Assests/Frame 2147227264.svg";
import payslip from "../../Assests/Frame 2147227250.svg";
import payrollempl from "../../Assests/Frame 2147227257.png";
import Frame from "../../Assests/Frame21472272523.svg";
import Frame2 from "../../Assests/Group 11.svg";
import Frame3 from "../../Assests/Group 1171275937.svg";
import webdesign1 from "../../Assests/Group11.png";
import webdesign2 from "../../Assests/Objects.svg";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";
import { Card, Row, Col } from "antd";

const StyledWrap = styled.div`
  padding-left: 120px;
  padding-right: 120px;
  .payroll-a {
    font-weight: 700;
    font-size: clamp(1.5rem, 2.5vw, 3rem);
    margin-top: 3vh;
  }
  .frame6-image {
    margin-top: 15vh;
  }
  .payroll-text {
    font-size: clamp(
      1.5rem,
      4vw,
      3.5rem
    ); /* Adjust font size based on screen resolution */
    font-weight: 700;
  }
  .text {
    margin-top: 3vh;
    font-weight: 400;
    font-size: clamp(1rem, 1.5vw, 1.5rem);
    color: #636980;
  }
  .text1 {
    margin-top: 3vh;
    font-weight: 400;
    font-size: clamp(1rem, 1.5vw, 1.5rem);
    color: #636980;
  }
  .text-heading {
    font-size: clamp(1.5rem, 2.5vw, 2.5rem);
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }
  .text-heading1 {
    font-size: clamp(1.5rem, 2.5vw, 2.5rem);
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }
  .card-style1 {
    background-color: #e3e8fc;
    border-radius: 24px;
    padding: 1vh;
    width: 100%;
    height: 26vh;
    margin-top: 3vh;
    color: #1f243b;
  }
  .card-content1 {
    color: #636980;
    font-size: clamp(1rem, 1.2vw, 1.2rem);
    font-weight: 400;
    margin-top: 2vh;
  }
  .complexity-heading {
    font-size: clamp(1.5rem, 2.5vw, 2.5rem);
    font-weight: 700;
    margin-top: 3vh;
  }
  .tick-text {
    display: flex;
    align-items: center;
    gap: 0.8vw;
    font-size: clamp(1rem, 1.5vw, 1.5rem);
    margin-bottom: 10px; /* Added gap between points */
  }
  .tick-text1 {
    display: flex;
    align-items: center;
    gap: 0.8vw;
    font-size: clamp(1rem, 1.5vw, 1.5rem);
    margin-bottom: 10px; /* Added gap between points */
  }
  .self-service-heading {
    margin-top: 3vh;
    font-weight: 500;
    font-size: clamp(1.5rem, 2vw, 2rem);
  }
  .contactus-card {
    background-color: #ffbb3e;
    border-radius: 24px;
    width: 100%;
    height: 39vh;
    margin-bottom: 30px;
  }
  .compliance {
    font-size: clamp(
      2rem,
      4vw,
      3rem
    ); /* Adjust font size based on screen resolution */
  }
  .compliance p {
    font-size: clamp(
      2rem,
      4vw,
      3rem
    ); /* Adjust font size based on screen resolution */
  }
  .wrapstyle {
    margin-left: auto;
    margin-right: auto;
    width: 60%;
    text-align: center;
    margin-bottom: 50px;
    font-size: 1rem; /* Decreased text size */
  }
  @media (max-width: 1024px) {
    .payroll-text {
      font-size: clamp(
        1.2rem,
        3vw,
        2.5rem
      ); /* Adjust font size for smaller screens */
      font-weight: 500;
    }
    .tick-text1 {
      font-size: clamp(
        0.9rem,
        1.4vw,
        1.4rem
      ); /* Adjust font size for smaller screens */
    }
    .compliance {
      font-size: clamp(
        1.8rem,
        3.5vw,
        2.5rem
      ); /* Adjust font size for smaller screens */
    }
    .compliance p {
      font-size: clamp(
        1.8rem,
        3.5vw,
        2.5rem
      ); /* Adjust font size for smaller screens */
    }
  }
  @media (max-width: 768px) {
    .compliance-text {
      display: flex;
      flex-direction: column;
      font-size: 0.8rem; /* Decreased text size */
    }
    .frame9-image {
      margin-top: 90px;
    }
    .text1 {
      margin-top: -5px;
      font-size: 0.9rem;
    }
    .tick-text-container {
      flex-direction: column; /* Changed to column to fit one after another */
    }
    .payroll-text {
      font-size: clamp(
        1rem,
        2.5vw,
        2rem
      ); /* Adjust font size for smaller screens */
      font-weight: 500;
    }
    .frame10-image {
      margin-top: 150px;
    }
    .tick-text {
      font-size: 0.8rem; /* Decreased text size */
      margin-top: 10px;
    }
    .tick-text1 {
      font-size: clamp(
        0.8rem,
        1.3vw,
        1.3rem
      ); /* Adjust font size for smaller screens */
    }
    .report-text-container {
      display: flex;
      flex-direction: column; /* Changed to column to fit one after another */
    }
    .theme-filldbtn {
      margin-top: -70px; /* Move the contact button up by 70px */
    }
    .compliance {
      font-size: clamp(
        1.5rem,
        3vw,
        2rem
      ); /* Adjust font size for smaller screens */
    }
    .compliance p {
      font-size: clamp(
        1.5rem,
        3vw,
        2rem
      ); /* Adjust font size for smaller screens */
    }
  }
  @media (max-width: 425px) {
    .frame5-image {
      margin-top: 7vh;
    }
    .frame6-image {
      margin-top: -60px;
      display: block; /* Ensure the logo is displayed */
    }

    .frame9-image {
      display: none; /* Hide the person image */
    }

    .theme-filldbtn {
      margin-top: -50px; /* Move the contact button up by 50px */
    }
    .payroll-text {
      font-size: clamp(
        0.8rem,
        2vw,
        1.5rem
      ); /* Adjust font size for smaller screens */
      font-weight: 500;
    }
    .tick-text1 {
      font-size: clamp(
        0.7rem,
        1.2vw,
        1.2rem
      ); /* Adjust font size for smaller screens */
    }
    .compliance {
      font-size: clamp(
        1.2rem,
        2.5vw,
        1.5rem
      ); /* Adjust font size for smaller screens */
    }
    .compliance p {
      font-size: clamp(
        1.2rem,
        2.5vw,
        1.5rem
      ); /* Adjust font size for smaller screens */
    }
    .wrapstyle {
      width: 100%; /* Adjust width for smaller screens */
    }

    .text-heading1 {
      margin-top: -17px;
    }
  }

  @media (max-width: 375px) {
    .text-heading1 {
      font-size: 21px;
    }
    .payroll-text {
      font-size: 24px;
    }
  }
  @media (max-width: 320px) {
    .text-heading1 {
      font-size: 20px;
    }
    .wrapstyle {
      font-size: 13px;
    }
  }
`;

const Knowmore = ({ setColor }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setColor(false);
  }, []);

  return (
    <StyledWrap>
      <Row className="frame-container">
        <Col xs={24} md={12} lg={12} xl={12} className="wrap-items">
          <img src={logo} alt="Frame" className="frame6-image" />
          <p className="payroll-text">
            Payroll Simplified for Modern Businesses
          </p>
          <p className="text">
            Whether you’re a small business or a growing enterprise,
            <br />
            ForesytsPay takes care of every aspect of payroll <br />
            processing, so you can focus on what truly matters—your <br />
            people.
          </p>
        </Col>
        <Col xs={24} md={12} lg={12} xl={12}>
          <img src={People} alt="Frame" className="frame5-image" />
        </Col>
      </Row>
      <div>
        <p className="text-heading">Automated & Accurate Payroll Processing</p>
        <p className="text wrapstyle">
          With just a few clicks, payroll is ready for disbursement. ForesytsPay
          automatically processes salaries, eliminating errors and reducing
          processing time. No more spreadsheets, no more manual calculations
          irrespective of the size of your organization.
        </p>
      </div>
      <div className="payroll-style">
        <img src={payroll} alt="Frame" className="frame8-image" />
      </div>
      <Card
        style={{
          backgroundColor: "#FFE0E0",
          width: "100%",
          height: "529px",
          marginTop: "210px",
        }}
      >
        <Row className="wrap6">
          <Col xs={24} md={12} lg={12} xl={12}>
            <div className="compliance">
              <p
                style={{
                  fontSize: "42px",
                  fontWeight: "700",
                }}
              >
                Compliance Without Complexity
              </p>
            </div>
            <div className="compliance-text">
              <p className="text1">
                Taxation and compliance can be overwhelming, but not with
                ForesytsPay. The system ensures automatic tax calculations,
                statutory deductions, and compliance with labor laws—all
                tailored to your region.
              </p>
              <div
                className="tick-text-container"
                style={{ marginTop: "11px" }}
              >
                <p className="tick-text1">
                  <img src={Tick} alt="Tick" />
                  Manages social security, and other statutory contributions
                </p>
                <p className="tick-text1">
                  <img src={Tick} alt="Tick" />
                  Generate and manage reports
                </p>
                <p class="tick-text1">
                  <img src={Tick} alt="Tick" />
                  Stay updated with changing labor laws and tax regulations
                </p>
              </div>
            </div>
          </Col>
          <Col xs={24} md={12} lg={12} xl={12} className="text-center">
            <div className="p-5">
              <img src={person} alt="Frame" className="frame9-image" />
            </div>
          </Col>
        </Row>
      </Card>
      <div>
        <p className="text-heading">Employee Self-Service</p>
        <p className="text wrapstyle">
          Empower employees with a self-service dashboard where they can access
          all payroll-related information without HR intervention.
        </p>
      </div>
      <div className="frame-container mx-5 px-5">
        <img src={Frame} alt="Frame" className="frame11-image" />
      </div>
      <Card
        style={{
          width: "100%",
          height: "509px",
          marginTop: "50px",
          marginBottom: "50px",
        }}
      >
        <Row className="wrap4">
          <Col xs={24} md={12} lg={12} xl={12}>
            <p className="text-heading">Advanced Payroll Insights & Reports</p>
            <div className="report-a-container">
              <p className="text">
                Get a clear picture of payroll expenses with in-depth reports
                and analytics. Track salary trends, tax liabilities, and
                compliance statuses—all in one dashboard.
              </p>
              <div style={{ marginTop: "25px" }}>
                <p className="tick-text">
                  <img src={Tick} alt="Tick" />
                  Generate payroll summaries for accounting teams
                </p>
                <p className="tick-text">
                  <img src={Tick} alt="Tick" />
                  Track monthly, quarterly, and yearly salary expenses
                </p>
                <p className="tick-text">
                  <img src={Tick} alt="Tick" />
                  Export detailed reports for audits and compliance checks
                </p>
              </div>
            </div>
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <img src={payrollempl} alt="Frame" className="frame10-image" />
          </Col>
        </Row>
      </Card>
      <Card className="contactus-card" style={{ overflow: "hidden" }}>
        <img
          src={Frame2}
          alt="Frame"
          style={{
            position: "absolute",
            width: "320px",
            top: "-10px",
            left: "-1px",
            overflow: "hidden",
          }}
        />

        <p className="text-heading1">Run Payroll Faster Than Ever</p>
        <p className="wrapstyle">
          With ForesytsPay, payroll becomes effortless. The system ensures
          everything runs smoothly, so you can focus on growing your business.
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "-60px",
          }}
        >
          <button
            className="theme-filldbtn my-4"
            onClick={() => {
              navigate("/contactus");
            }}
          >
            Contact Us
          </button>
        </div>
        <img
          src={Frame3}
          alt="Frame"
          style={{
            position: "absolute",
            width: "450px",
            top: "-200px",
            right: "-100px",
            overflow: "hidden",
          }}
        />
      </Card>
    </StyledWrap>
  );
};

export default Knowmore;
